// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_NewsCreationForm__R3McD{
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    background-color: white;
    margin-bottom: 20px;
    border-radius: 12px;
}
.styles_NewsLanguage__ShJwK{
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
}

.styles_InputFields__4PNBU {
    margin-top: 30px!important;
    margin-right: 30px!important;
    margin-left: 30px!important;
}
.styles_Textarea__i0UJa {
    margin-top: 30px!important;
    margin-right: 30px!important;
    margin-left: 30px!important;
    resize: none;
    height: 300px;
    padding-top: 16.5px;
    padding-bottom: 16.5px;
    padding-left: 14px;
    padding-right: 14px;
    border-radius: 4px;
    border: 1px solid rgba(107, 103, 103, 0.541);

    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-size: 16px;
}
.styles_Textarea__i0UJa:focus {
    outline: none;
    border: 2px solid rgba(8, 123, 255, 0.788);
}
.styles_CountryCityRow__VRaYz{
    display: flex;
    justify-content: start;
}
.styles_CountryCityRow__VRaYz > * {
    width: 100px;
}
.styles_WeightHeightRow__HcKOV{
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
}
.styles_WeightHeightRow__HcKOV > * {
    width: 400px;
}

.styles_MainNews__tR2mF{
    margin-top: 20px;
    display: flex;    
    flex-direction: column;
    border-radius: 25px;
    height: 100%;
    max-width: 800px;
    min-width: 800px;
    max-height: 600px;
    height: 600px;
    position: relative;
    overflow: hidden;
    background-color: #EBF8FF;
    border: 1px solid #00a6ff;

    .styles_PromoBanner__7-Q4X {
        position: relative;
        flex: 1 1;
        height: auto;
        width: auto;
        aspect-ratio: 16 / 9; 
        border-radius: 25px;

        >img {
            position: absolute;
            background: transparent;
            width: 100%;
            height: 100%;
            object-fit: cover;
            left: 0;
            border-radius: 25px;
        }

        .styles_gradient__3SuMa{
            border-radius: 25px;
            position: absolute;
            width: 100%;
            height: 100%;
            background: rgba(17, 80, 123, 0.5);
        }
    }

    .styles_TextContent__YvYs3{
        width: 800px;
        min-height: 100px;
        
        position: relative;
        display: flex;
        background-color: #EBF8FF;
        flex-direction: column;
        justify-content: center;
        align-items: start;
        color: #000000;
        
        padding-left: 20px;

        .styles_TopHeader__4dqMC {
            position: absolute;
            font-family: 'Montserrat';
            font-size: 25px;
            font-weight: bold;
            line-height: 30px;
            letter-spacing: 0em;
            text-align: left;
            color: #fff;

            top: -90px;
        
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }
        .styles_SecondHeader__bj54C{
            position: absolute;
            font-family: 'Montserrat';
            font-size: 25px;
            font-weight: bold;
            line-height: 30px;
            letter-spacing: 0em;
            text-align: left;
            text-transform: uppercase;
            color: #fff;

            top: -50px;
        
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
        }
        .styles_ShortContent__cXTaz{
            font-family: 'Lato';
            font-size: 20px;
            font-weight: medium;
            line-height: 24px;
            letter-spacing: 0em;
            text-align: left;
            color: #195679;
        
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
        
            padding-right: 10px;
        }
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/NewsPage/ui/news-creation-form/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;AAC/B;AACA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,2BAA2B;IAC3B,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,4CAA4C;;IAE5C,uDAAuD;IACvD,eAAe;AACnB;AACA;IACI,aAAa;IACb,0CAA0C;AAC9C;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;;IAEzB;QACI,kBAAkB;QAClB,SAAO;QACP,YAAY;QACZ,WAAW;QACX,oBAAoB;QACpB,mBAAmB;;QAEnB;YACI,kBAAkB;YAClB,uBAAuB;YACvB,WAAW;YACX,YAAY;YACZ,iBAAiB;YACjB,OAAO;YACP,mBAAmB;QACvB;;QAEA;YACI,mBAAmB;YACnB,kBAAkB;YAClB,WAAW;YACX,YAAY;YACZ,kCAAkC;QACtC;IACJ;;IAEA;QACI,YAAY;QACZ,iBAAiB;;QAEjB,kBAAkB;QAClB,aAAa;QACb,yBAAyB;QACzB,sBAAsB;QACtB,uBAAuB;QACvB,kBAAkB;QAClB,cAAc;;QAEd,kBAAkB;;QAElB;YACI,kBAAkB;YAClB,yBAAyB;YACzB,eAAe;YACf,iBAAiB;YACjB,iBAAiB;YACjB,mBAAmB;YACnB,gBAAgB;YAChB,WAAW;;YAEX,UAAU;;YAEV,oBAAoB;YACpB,qBAAqB;YACrB,4BAA4B;YAC5B,gBAAgB;QACpB;QACA;YACI,kBAAkB;YAClB,yBAAyB;YACzB,eAAe;YACf,iBAAiB;YACjB,iBAAiB;YACjB,mBAAmB;YACnB,gBAAgB;YAChB,yBAAyB;YACzB,WAAW;;YAEX,UAAU;;YAEV,oBAAoB;YACpB,qBAAqB;YACrB,4BAA4B;YAC5B,gBAAgB;QACpB;QACA;YACI,mBAAmB;YACnB,eAAe;YACf,mBAAmB;YACnB,iBAAiB;YACjB,mBAAmB;YACnB,gBAAgB;YAChB,cAAc;;YAEd,oBAAoB;YACpB,qBAAqB;YACrB,4BAA4B;YAC5B,gBAAgB;;YAEhB,mBAAmB;QACvB;IACJ;AACJ","sourcesContent":[".NewsCreationForm{\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n    align-items: center;\n    background-color: white;\n    margin-bottom: 20px;\n    border-radius: 12px;\n}\n.NewsLanguage{\n    width: 100%;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n}\n\n.InputFields {\n    margin-top: 30px!important;\n    margin-right: 30px!important;\n    margin-left: 30px!important;\n}\n.Textarea {\n    margin-top: 30px!important;\n    margin-right: 30px!important;\n    margin-left: 30px!important;\n    resize: none;\n    height: 300px;\n    padding-top: 16.5px;\n    padding-bottom: 16.5px;\n    padding-left: 14px;\n    padding-right: 14px;\n    border-radius: 4px;\n    border: 1px solid rgba(107, 103, 103, 0.541);\n\n    font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n    font-size: 16px;\n}\n.Textarea:focus {\n    outline: none;\n    border: 2px solid rgba(8, 123, 255, 0.788);\n}\n.CountryCityRow{\n    display: flex;\n    justify-content: start;\n}\n.CountryCityRow > * {\n    width: 100px;\n}\n.WeightHeightRow{\n    margin-bottom: 20px;\n    display: flex;\n    justify-content: space-between;\n}\n.WeightHeightRow > * {\n    width: 400px;\n}\n\n.MainNews{\n    margin-top: 20px;\n    display: flex;    \n    flex-direction: column;\n    border-radius: 25px;\n    height: 100%;\n    max-width: 800px;\n    min-width: 800px;\n    max-height: 600px;\n    height: 600px;\n    position: relative;\n    overflow: hidden;\n    background-color: #EBF8FF;\n    border: 1px solid #00a6ff;\n\n    .PromoBanner {\n        position: relative;\n        flex: 1;\n        height: auto;\n        width: auto;\n        aspect-ratio: 16 / 9; \n        border-radius: 25px;\n\n        >img {\n            position: absolute;\n            background: transparent;\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n            left: 0;\n            border-radius: 25px;\n        }\n\n        .gradient{\n            border-radius: 25px;\n            position: absolute;\n            width: 100%;\n            height: 100%;\n            background: rgba(17, 80, 123, 0.5);\n        }\n    }\n\n    .TextContent{\n        width: 800px;\n        min-height: 100px;\n        \n        position: relative;\n        display: flex;\n        background-color: #EBF8FF;\n        flex-direction: column;\n        justify-content: center;\n        align-items: start;\n        color: #000000;\n        \n        padding-left: 20px;\n\n        .TopHeader {\n            position: absolute;\n            font-family: 'Montserrat';\n            font-size: 25px;\n            font-weight: bold;\n            line-height: 30px;\n            letter-spacing: 0em;\n            text-align: left;\n            color: #fff;\n\n            top: -90px;\n        \n            display: -webkit-box;\n            -webkit-line-clamp: 1;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n        }\n        .SecondHeader{\n            position: absolute;\n            font-family: 'Montserrat';\n            font-size: 25px;\n            font-weight: bold;\n            line-height: 30px;\n            letter-spacing: 0em;\n            text-align: left;\n            text-transform: uppercase;\n            color: #fff;\n\n            top: -50px;\n        \n            display: -webkit-box;\n            -webkit-line-clamp: 1;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n        }\n        .ShortContent{\n            font-family: 'Lato';\n            font-size: 20px;\n            font-weight: medium;\n            line-height: 24px;\n            letter-spacing: 0em;\n            text-align: left;\n            color: #195679;\n        \n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n        \n            padding-right: 10px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"NewsCreationForm": `styles_NewsCreationForm__R3McD`,
	"NewsLanguage": `styles_NewsLanguage__ShJwK`,
	"InputFields": `styles_InputFields__4PNBU`,
	"Textarea": `styles_Textarea__i0UJa`,
	"CountryCityRow": `styles_CountryCityRow__VRaYz`,
	"WeightHeightRow": `styles_WeightHeightRow__HcKOV`,
	"MainNews": `styles_MainNews__tR2mF`,
	"PromoBanner": `styles_PromoBanner__7-Q4X`,
	"gradient": `styles_gradient__3SuMa`,
	"TextContent": `styles_TextContent__YvYs3`,
	"TopHeader": `styles_TopHeader__4dqMC`,
	"SecondHeader": `styles_SecondHeader__bj54C`,
	"ShortContent": `styles_ShortContent__cXTaz`
};
export default ___CSS_LOADER_EXPORT___;
